function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 2c.513 0 .936.386.993.883L21 3v6.64c-.117 5.412-3.509 10.236-8.63 12.288-.239.096-.505.096-.744 0-5.017-2.012-8.373-6.685-8.615-11.984L3 9.62V3c0-.513.386-.936.883-.993L4 2h16zm-1.001 2h-14v5.598c.093 4.294 2.615 8.162 6.509 10.088l.287.138.203.09.203-.09c3.865-1.786 6.449-5.454 6.768-9.582l.02-.318.011-.305L18.999 4zM9.511 6.14l.102.07.094.083L12 8.585l2.293-2.292c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L13.415 10l2.292 2.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083L12 11.415l-2.293 2.292c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L10.585 10 8.293 7.707c-.39-.39-.39-1.024 0-1.414.33-.33.835-.381 1.218-.153z"
});

var SvgDenied = function SvgDenied(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDenied, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/denied.b334100d.svg";
export { ForwardRef as ReactComponent };